"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileVersion = void 0;
const crypto_1 = require("@akord/crypto");
class FileVersion extends crypto_1.Encryptable {
    constructor(fileVersionProto, keys, publicKey) {
        super(keys, publicKey);
        this.owner = fileVersionProto.owner;
        this.createdAt = fileVersionProto.createdAt;
        this.type = fileVersionProto.type;
        this.resourceUri = fileVersionProto.resourceUri;
        this.size = fileVersionProto.size;
        this.numberOfChunks = fileVersionProto.numberOfChunks;
        this.chunkSize = fileVersionProto.chunkSize;
        this.name = fileVersionProto.name;
        this.status = fileVersionProto.status;
        this.udl = fileVersionProto.udl;
        this.ucm = fileVersionProto.ucm;
    }
    getUri(type) {
        var _a, _b;
        return (_b = (_a = this.resourceUri) === null || _a === void 0 ? void 0 : _a.find(uri => uri.startsWith(type))) === null || _b === void 0 ? void 0 : _b.replace(type, "");
    }
}
__decorate([
    (0, crypto_1.encrypted)()
], FileVersion.prototype, "name", void 0);
exports.FileVersion = FileVersion;
